import { render, staticRenderFns } from "./IrisSwitch.vue?vue&type=template&id=c0d3820a&"
import script from "./IrisSwitch.vue?vue&type=script&lang=ts&"
export * from "./IrisSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSwitch.vue?vue&type=style&index=0&id=c0d3820a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports